import AuthLayout from '../layouts/AuthLayout.vue'

export default {
  path: '/',
  name: 'authorization',
  component: AuthLayout,
  redirect: {
    name: 'auth.login',
  },
  children: [
    {
      path: '/login',
      name: 'auth.login',
      component: () => import('@/views/AuthView.vue'),
      meta: {
        title: 'Sign in',
      },
    },
    {
      path: '/magic-link',
      name: 'auth.magic-link',
      component: () => import('@/views/auth/MagicLinkPage.vue'),
      meta: {
        title: 'Log in',
      },
    },
    {
      path: '/accept-invitation',
      name: 'auth.accept-invitation',
      component: () => import('@/views/auth/AcceptInvitationPage.vue'),
      meta: {
        title: 'Accept invitation',
      },
    },
    {
      path: '/forgot-password',
      name: 'auth.forgot-password',
      component: () => import('@/views/auth/ForgotPasswordPage.vue'),
      meta: {
        title: 'Forgot password',
      },
    },
    {
      path: '/reset-password',
      name: 'auth.reset-password',
      component: () => import('@/views/auth/PasswordResetForm.vue'),
      meta: {
        title: 'Create a new password',
      },
    },
  ],
}
